import { useQuery } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../@types/ErrorHandling'
import { api } from '../../Services/API'
import { GetEntityDetailsForSummaryDocumentRequest } from '../../Types/getEntityDetailsForSummaryDocument'
import { API_ROUTES } from '../../constants/apiRoutes'
import { QUERY_KEYS } from '../../constants/queryKeys'

const request = async (payload: any) => {
  const response = await api.post<GetEntityDetailsForSummaryDocumentRequest>(
    API_ROUTES.getEntityDetailsForSummaryDocument,
    payload,
  )

  return response.data
}

export const useGetEntityDetailsForSummaryDocument = (
  payload: any,
  isEnabled: any,
) => {
  return useQuery<
    GetEntityDetailsForSummaryDocumentRequest,
    AxiosError<ErrorHandling[]>
  >({
    queryKey: [
      QUERY_KEYS.getEntityDetailsForSummaryDocument,
      payload.vatNumber,
    ],
    queryFn: () => request(payload),
    enabled: isEnabled,
  })
}
